module.exports = __webpack_public_path__ + "static/b125c3a61f44fc9ab8cc257598f819ee3763640e376c5ea0097eeadfe4522e79-ab7161a932022ba7521ee24ce7a6bd75.png";